// extracted by mini-css-extract-plugin
export default {"root":"PreviewProduct_root__DJYWX"};